import { Component, OnInit } from '@angular/core';
import { DwNewRouteKeyService, GetloadingService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MallService} from './implementation/programs/mall/mall.service';


@Component({
  selector: 'app-prog001',
  template: `
        <div class="fx_404">
            <img src="assets/img/home/404.svg" />
            <div><a class="back-home" (click)="openHome()">回到首页</a></div>
        </div>
    `,
    styles: [`
    .fx_404 {
      background: #fff;
      text-align: center;
      padding: 40px;
      height: 100%;
    }
    .fx_404 img {
      max-width: 400px;
    }
    .fx_404 .back-home{
      padding: 10px;
      border: 1px solid #1890ff;
      border-radius: 5px;
      font-size: 16px;
      display: inline-block;
      margin-top: 30px;
    }
    `]
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    protected http: FxDapHttpClient,
    public load: GetloadingService,
    private fxUserService: FxUserInfoService,
    public router: DwNewRouteKeyService,
    public router2: Router,
    protected route: ActivatedRoute,
    public mallService: MallService, // 当前响应式平台
  ) { }

  ngOnInit(): void {
  }
  // 回到首页
  openHome() {
    this.router.navigate(['mall/mallhome'], this.mallService.getQueryParams());
  }
}
